import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from "@angular/forms";

export interface CustomerOnBoarding {
  name: string;
  billingEmail: string;
  businessNumber: string;
  loggedInEmail: string;
  taxId: { value: string };
  taxIdType: { value: string };
  language: string;
  // businessNumber: string;
  country: string;
  state: { id: string; value: string };
  streetAddress: string;
  streetAddress2: string;
  suburb: string;
  postCode: string;
  agreed: boolean;
  agreedBy: string;
  reviewConfirmed: boolean;
  userList: {
    username: string;
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    language: string;
    weChatId: string;
  }[];
}

export interface ReferenceValue {
  id: string;
  name: string;
  code: string;
  internalCode: string;
  value: string;
}

export interface State {
  id: string;
  name: string;
  code: string;
}

export interface CloneLogFile {
  fileName: string;
  lastModified: string;
  fileSize: number;
}

export interface Country {
  id: number;
  name: string;
  code: string;
}

export interface UploadedFile {
  file: File;
  id: string;
  url: string;
}

export interface Language {}


export function strictEmailValidator(): ValidatorFn {
  const relaxedButStrictRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return relaxedButStrictRegex.test(control.value) ? null : { strictEmail: true };
  };
}

export function duplicateUsernameValidator(usersArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentUsername = control.value?.trim()?.toLowerCase();
    if (!currentUsername) return null;

    const duplicates = usersArray.controls.filter(c =>
      c.get('username')?.value?.trim()?.toLowerCase() === currentUsername
    );

    return duplicates.length > 1 ? { duplicateUsername: true } : null;
  };
}